let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2NpA2")).then(() => parcelRequire('laYU1'));